export const EViewInfoPriority = {
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  TOP: 'TOP',
};
